import { Button, MenuItem } from "@mui/material";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import FormikSelect from "../../../commons/formik/formikSelect";
import { StyledXML } from "../../../styled/xml";
import XmlTextArea from "./xmlTextArea";
import XmlValidationTable from "./xmlValidationTable";

const XmlValidationForm = ({
    validations,
    xmlTypeOptions,
    handleValidateXML
}) => {

    const initialValues = {
        xmlType: "",
        xmlCode: ""
    };

    const validationSchema = Yup.object({
        xmlType: Yup.string().required("Debe seleccionar un tipo de XML"),
        xmlCode: Yup.string().required("El código XML no puede estar vacío")
    });

    const handlePaste = async (setFieldValue) => {
        const text = await navigator.clipboard.readText();
        setFieldValue('xmlCode', text);
    };

    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={(values) => {
                    handleValidateXML(values.xmlType, values.xmlCode);
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <StyledXML.Paper>
                            <FormikSelect
                                name="xmlType"
                                label="Tipo de XML"
                            >
                                {xmlTypeOptions?.map((option) => (
                                    <MenuItem key={option.id} value={option.id}>
                                        {option.nombre}
                                    </MenuItem>
                                ))}
                            </FormikSelect>
                        </StyledXML.Paper>
                        <StyledXML.Paper>
                            <StyledXML.CodeContainer>
                                <XmlTextArea
                                    value={values.xmlCode}
                                    onChange={(value) => setFieldValue('xmlCode', value)}
                                    onPaste={() => handlePaste(setFieldValue)}
                                    label="Código XML"
                                    placeholder="Pega el código XML aquí o arrastra un archivo .xml..."
                                    acceptedFileTypes={{
                                        "text/xml": [".xml"],
                                        "application/xml": [".xml"]
                                    }}
                                    name="xmlCode"
                                />
                                <Button
                                    type="submit"
                                    variant="contained"
                                >
                                    Validar
                                </Button>
                            </StyledXML.CodeContainer>
                        </StyledXML.Paper>
                    </Form>
                )}
            </Formik>
            <XmlValidationTable
                validations={validations}
            />
        </>
    );
};

export default XmlValidationForm;